// The Settings section nav (Settings board): Shared, Renewals, then the Admin group at the very bottom
// with everything only the Admin sees. A section not built yet shows disabled with the reason
// (shell/placeholders.ts), so none leads nowhere.
import { useNavigate } from 'react-router';
import { useUser } from '../auth/user';
import { PlaceholderButton } from '../shell/Placeholder';
import type { PlaceholderId } from '../shell/placeholders';

type Section = { path: string; label: string } | { soon: PlaceholderId; label: string };

const shared: Section[] = [
  { path: '/settings', label: 'Users' },
  { soon: 'settings.carriers', label: 'Carriers' },
  { soon: 'settings.banks', label: 'Banks' },
  { path: '/settings/ams360', label: 'AMS360' },
];
const renewals: Section[] = [
  { path: '/settings/statuses', label: 'Statuses' },
  { path: '/settings/urgency', label: 'Urgency and window' },
  { soon: 'settings.handoffs', label: 'Handoffs' },
  { path: '/settings/templates', label: 'Templates' },
  { soon: 'settings.assignment', label: 'Assignment rules' },
  { soon: 'settings.export', label: 'Export' },
  { path: '/settings/defaults', label: 'Defaults' },
  { path: '/settings/sheets', label: 'Renewal sheets' },
];
const adminOnly: Section[] = [
  { path: '/settings/integrations', label: 'Integrations' },
  { path: '/settings/activity', label: 'Activity log' },
];

export function SettingsNav({ current }: { current: string }) {
  const navigate = useNavigate();
  const { role } = useUser();
  const groups: [string, Section[]][] = [
    ['Shared', shared],
    ['Renewals', renewals],
  ];
  if (role === 'Admin') groups.push(['Admin', adminOnly]);
  return (
    <nav className="snav" aria-label="Settings sections">
      {groups.map(([label, sections]) => (
        <div key={label} className="snav-g" role="group" aria-label={label}>
          <div className="snav-l">{label}</div>
          {sections.map((s) =>
            'soon' in s ? (
              <PlaceholderButton key={s.label} id={s.soon} className="snav-b" block>
                {s.label}
              </PlaceholderButton>
            ) : (
              <button
                key={s.path}
                type="button"
                className={s.path === current ? 'snav-b on' : 'snav-b'}
                aria-current={s.path === current ? 'page' : undefined}
                onClick={() => navigate(s.path)}
              >
                {s.label}
              </button>
            ),
          )}
        </div>
      ))}
    </nav>
  );
}
